// WordViewer.tsx
import React, { useEffect, useRef } from 'react';
import { renderAsync } from 'docx-preview';

export const WordViewer: React.FC<{ blob: Blob }> = ({ blob }) => {
  const container = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // guard clause – no blob, nothing to render, nothing to clean
    if (!blob || !container.current) return;

    const el = container.current; // 1️⃣ keep a stable reference

    renderAsync(blob, el, undefined, {
      className: 'docx',
      inWrapper: true,
    }).catch(console.error);

    // 2️⃣ always return a cleanup, but touch `el`, not `container.current`
    // eslint-disable-next-line consistent-return
    return () => {
      el.innerHTML = '';
    };
  }, [blob]);

  return <div ref={container} style={{ width: '100%', height: '100%', overflow: 'auto' }} />;
};
